import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'ngb-substation-edit-modal-content',
  templateUrl: './substation-edit-modal.component.html'
})
export class NgbSubstationEditModalContent {
  @Input() name;
  @Input() substation;

  constructor(public activeModal: NgbActiveModal) { }

  tx1Options: string[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14",
                          "15", "16", "17", "18", "19", "20", "21", "22", "23", "24"];
  selectedTX1Option: string = "Select T1 option...";

  tx2Options: string[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14",
                          "15", "16", "17", "18", "19", "20", "21", "22", "23", "24"];
  selectedTX2Option: string = "Select T2 option...";

  tx3Options: string[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14",
                          "15", "16", "17", "18", "19", "20", "21", "22", "23", "24"];
  selectedTX3Option: string = "Select T3 option...";

  tx4Options: string[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14",
                          "15", "16", "17", "18", "19", "20", "21", "22", "23", "24"];
  selectedTX4Option: string = "Select T4 option...";

  tx5Options: string[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14",
                          "15", "16", "17", "18", "19", "20", "21", "22", "23", "24"];
  selectedTX5Option: string = "Select T5 option...";

  tx6Options: string[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14",
                          "15", "16", "17", "18", "19", "20", "21", "22", "23", "24"];
  selectedTX6Option: string = "Select T6 option...";

  ChangeTX1Option(newOption: string) { 
    this.selectedTX1Option = newOption;
  }

  ChangeTX2Option(newOption: string) { 
    this.selectedTX2Option = newOption;
  }

  ChangeTX3Option(newOption: string) { 
    this.selectedTX3Option = newOption;
  }

  ChangeTX4Option(newOption: string) { 
    this.selectedTX4Option = newOption;
  }

  ChangeTX5Option(newOption: string) { 
    this.selectedTX5Option = newOption;
  }

  ChangeTX6Option(newOption: string) { 
    this.selectedTX6Option = newOption;
  }
}
